// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"0773ab45","826":"214d8246","969":"6864e806","1240":"c0634304","1901":"4c9461b1","3098":"4db79368","3178":"352f2d0f","4282":"dc34d244","5895":"f682b1a7","6485":"2de78bbe","7051":"6c5cedf4","9273":"a6edab77"}[chunkId] + ".chunk.css";
};